
import {searchReducer} from './searchReducer'

export * from './searchActions';
export default searchReducer;